import React from 'react';
import { Rifm } from 'rifm';
import Input2, { InputType } from '../input/Input2';

const formatSsn = (value: string) => {
  const cleanSsn = value.replace(/[^\d]+/gi, '');
  const ssnParts = [
    cleanSsn.substring(0, 3),
    cleanSsn.substring(3, 5),
    cleanSsn.substring(5, 9),
  ].filter((part) => Boolean(part));

  return ssnParts.join('-');
};

export interface ISsnProps {
  onChange: (value: string, name: string) => void;
  value: string;
  name: string;
  className?: string;
  placeholder: string;
  width: number | string;
  stretch: boolean;
  disabled: boolean;
  dataAt?: string;
  label?: string | React.ReactChild;
  error?: string;
}

export interface ISsnState {
  ssn: string;
}

export default class Ssn extends React.Component<ISsnProps> {
  public static defaultProps = {
    width: '',
    value: '',
    stretch: false,
    placeholder: 'XXX-XX-XXXX',
    disabled: false,
  };

  public state = {
    ssn: '',
  };

  public componentDidMount() {
    this.setState(() => ({ ssn: formatSsn(this.props.value || '') }));
  }

  public static getDerivedStateFromProps(nextProps:ISsnProps) {
    return {
      ssn: formatSsn(nextProps.value),
    };
  }

  private handleOnChange = (value: string): void => {
    this.setState(() => ({ ssn: value }));
    this.props.onChange(value.replace(/[^\d]+/gi, ''), this.props.name);
  };

  public render() {
    const { ssn } = this.state;
    return (
      <Rifm
        accept={/\d+/g}
        format={formatSsn}
        value={ssn}
        onChange={this.handleOnChange}
      >
        {({ value, onChange }: { value:string, onChange:any }) => (
          <Input2 {...this.props} type={InputType.Number} value={value} onChange={onChange} />
        )}
      </Rifm>
    );
  }
}
